import { connect } from 'react-redux';
import { translate } from 'jitsi/base/i18n/functions';
import AbstractButton from 'jitsi/base/toolbox/components/AbstractButton';
import { IconHideCameraOff } from 'jitsi/base/icons/svg';
import { shouldHideCameraOffParticipants, toggleHideCameraOffParticipants, } from 'context/video-grid/functions';
class HideCameraOffButton extends AbstractButton {
    constructor(props) {
        super(props);
        this.icon = IconHideCameraOff;
        this.tooltip = 'toolbar.accessibilityLabel.hideCameraOff';
        this.accessibilityLabel = 'toolbar.accessibilityLabel.hideCameraOff';
        this.label = 'toolbar.hideCameraOff';
        this.toggledAccessibilityLabel = 'toolbar.accessibilityLabel.showCameraOff';
        this.toggledLabel = 'toolbar.accessibilityLabel.showCameraOff';
        this.toggledTooltip = 'toolbar.showCameraOff';
        this.toggleHideCameraOffParticipants = this.toggleHideCameraOffParticipants.bind(this);
    }
    toggleHideCameraOffParticipants() {
        const { toggleHideCameraOffParticipants, isCurrentlyHidden } = this.props;
        toggleHideCameraOffParticipants(!isCurrentlyHidden);
    }
    _isToggled() {
        return this.props.isCurrentlyHidden;
    }
    _handleClick() {
        return this.toggleHideCameraOffParticipants();
    }
}
const mapStateToProps = (state) => {
    return {
        isCurrentlyHidden: shouldHideCameraOffParticipants(state),
    };
};
const mapDispatchToProps = {
    toggleHideCameraOffParticipants,
};
export default translate(connect(mapStateToProps, mapDispatchToProps)(HideCameraOffButton));
